import "./Notification.css";

export default function Notification({
  type = "info",
  title,
  message,
  closing = false,
  onClose,
}) {
  const config = {
    error: {
      icon: "fas fa-exclamation-triangle",
      className: "error",
      defaultTitle: "Erro",
    },
    success: {
      icon: "fas fa-check-circle",
      className: "success",
      defaultTitle: "Sucesso!",
    },
    warning: {
      icon: "fas fa-exclamation-circle",
      className: "warning",
      defaultTitle: "Atenção",
    },
    info: {
      icon: "fas fa-info-circle",
      className: "info",
      defaultTitle: "Informação",
    },
  };

  const { icon, className, defaultTitle } = config[type];

  return (
    <div className={`notification ${className} ${closing ? 'closing' : ''}`}>
      <div className="notification-content">
        <i className={icon}></i>

        <div className="notification-text">
          <strong>{title || defaultTitle}</strong>
          <span
            dangerouslySetInnerHTML={{
              __html: message?.replace(/\n/g, "<br>"),
            }}
          />
        </div>

        <button className="close-btn" onClick={onClose}>
          <i className="fas fa-times" />
        </button>
      </div>
    </div>
  );
}
